import {
  allContentStatsForCourseFetchErrored,
  allContentStatsForCourseFetchFinished,
  allContentStatsForCourseNeedsFetching,
  allSectionStatsForCourseFetchErrored,
  allSectionStatsForCourseFetchFinished,
  allSectionStatsForCourseNeedsFetching,
  courseStatFetchErrored,
  courseStatFetchFinished,
  courseStatNeedsFetching
} from "seneca-common/features/stats/state";
import { isSignedIn } from "seneca-common/features/user/state";

export function allStatsNeedFetchingForCourse(
  state: any,
  courseId: string
): boolean {
  return (
    isSignedIn(state) &&
    (courseStatNeedsFetching(state, courseId) ||
      allSectionStatsForCourseNeedsFetching(state, courseId) ||
      allContentStatsForCourseNeedsFetching(state, courseId))
  );
}

export function allStatsHaveFetchedForCourse(
  state: any,
  courseId: string
): boolean {
  return (
    courseStatFetchFinished(state, courseId) &&
    allSectionStatsForCourseFetchFinished(state, courseId) &&
    allContentStatsForCourseFetchFinished(state, courseId)
  );
}

export function allStatsHaveFetchedForCourseIfNeeded(
  state: any,
  courseId: string
): boolean {
  return !isSignedIn(state) || allStatsHaveFetchedForCourse(state, courseId);
}

export function allStatsForCourseFetchErrored(
  state: any,
  courseId: string
): boolean {
  return (
    courseStatFetchErrored(state, courseId) ||
    allSectionStatsForCourseFetchErrored(state, courseId) ||
    allContentStatsForCourseFetchErrored(state, courseId)
  );
}
